import {Status} from "src/constant";

// TODO : Remove list datastudio once migration to api is complete

export enum DataStudioEndpointType {
    JUPYTER_ENTERPRISE_GATEWAY = "JUPYTER_ENTERPRISE_GATEWAY"
}

export enum DataStudioOnboardingStatus {
    ACTIVE = "ACTIVE"
}

export enum DataStudioRegion {
    US_EAST_1 = "US_EAST_1"
}

export enum DataStudioTeamType {
    LDAP_GROUP = "LDAP_GROUP"
}

export interface DataStudioResourceMap {
    studioUrl?: string
}

export interface DataStudioOnboarding {
    onboardingId: string,
    name: string,
    teamIdentifier: string,
    status: DataStudioOnboardingStatus,
    accountId: string,
    region: DataStudioRegion,
    resources: DataStudioResourceMap,
    createdTimestamp: string,
    updatedTimestamp: string,
    createdBy: string
}

export enum DataStudioAddonStatus {
    CREATE_IN_PROGRESS = "CREATE_IN_PROGRESS",
    ACTIVE = "ACTIVE",
    FAILED = "FAILED",
    DELETED = "DELETED"
}

export enum DataStudioAddonType {
    JUPYTER_MANAGED_ENDPOINT = "JUPYTER_MANAGED_ENDPOINT"
}

export interface DataStudioAddon {
    addonId: string,
    name: string,
    status: DataStudioAddonStatus,
    type: DataStudioAddonType,
    createdBy: string,
    createdTimestamp: string
}

export interface DataStudioManagedEndpoint {
    onboardingId: string,
    name: string,
    virtualClusterId: string,
    releaseLabel: string,
    executionRoleArn: string,
    requestedBy?: string,
    createdBy?: string,
    updatedBy?: string,
    createdTimestamp?: string,
    updatedTimestamp?: string,
    type: DataStudioEndpointType | DataStudioAddonType,
    managedEndpointType?: DataStudioEndpointType,
    configurationOverrides: string,
    status?: string,
    addonId?: string
}

export interface DataStudioInitialState {
    listDataStudios: {
        dataStudios: [any],
        status: Status
    },
    onboarding: {
        value: DataStudioOnboarding,
        status: Status,
        error: string
    },
    managedEndpoint: {
        value: DataStudioManagedEndpoint,
        status: Status,
        error: string
    },
    listOnboardings: {
        value: DataStudioOnboarding[],
        status: Status,
        error: string
    },
    listAddons: {
        value: DataStudioAddon[],
        status: Status,
        error: string
    },
    addon : {
        status: Status,
        error: string
    }
}

export const dataStudioInitialState: DataStudioInitialState = {
    listDataStudios: {
        dataStudios: [{}],
        status: Status.LOADING
    },
    onboarding: {
        value: {
            onboardingId: "",
            name: "",
            teamIdentifier: "",
            status: DataStudioOnboardingStatus.ACTIVE,
            accountId: "",
            region: DataStudioRegion.US_EAST_1,
            resources: {},
            createdTimestamp: "",
            updatedTimestamp: "",
            createdBy: ""
        },
        status: Status.LOADING,
        error: ""
    },
    managedEndpoint: {
        value: {
            onboardingId: "",
            name: "",
            virtualClusterId: "",
            releaseLabel: "",
            executionRoleArn: "",
            requestedBy: "",
            type: DataStudioEndpointType.JUPYTER_ENTERPRISE_GATEWAY,
            configurationOverrides: "{}"
        },
        status: Status.LOADING,
        error: ""
    },
    listAddons: {
        value: [],
        status: Status.LOADING,
        error: ""
    },
    listOnboardings: {
        value: [],
        status: Status.LOADING,
        error: ""
    },
    addon: {
        status: Status.LOADING,
        error: ""
    }
}
